const SearchStorageKeys = {
  'recently-viewed-vehicles': 'recently-viewed-vehicles',
  usedCarsPreviousUrl: 'usedCarsPreviousUrl',
} as const

type SearchStorageKeys =
  (typeof SearchStorageKeys)[keyof typeof SearchStorageKeys]

export const setSessionStorage = (
  storageKey: SearchStorageKeys,
  value: string,
) => {
  if (typeof window !== 'undefined') {
    window.sessionStorage.setItem(storageKey, value)
  }
}

export const getSessionStorage = <T = unknown>(
  storageKey: SearchStorageKeys,
): T => {
  const storageValue = window.sessionStorage.getItem(storageKey)
  return typeof storageValue === 'string' ? JSON.parse(storageValue) : {}
}
